import * as React from "react";

import { mboxes } from "../../../../mbox";
import NavbarDropdown from "./NavbarDropdown";
import { updateNavStructure, ExtendedExperienceSelector } from "./ABTestUtils";

const renderNavbarDropdown = (navItem, index) => (
  <NavbarDropdown
    icon={navItem.label.icon}
    smallIcon={navItem.label.smallIcon}
    menuItems={navItem.menuItems}
    key={index + navItem.label}
    menuId={navItem.label.text.replace(/ /g, "_")}
    menuLabel={navItem.label.text}
    aria-label={navItem.label.text}
  >
    {navItem.label.text}
  </NavbarDropdown>
);

export const NavbarDropdownsList = ({ navStructure }) => (
  <ExtendedExperienceSelector mboxes={mboxes}>
    {(content) => (
      <>{updateNavStructure(content, navStructure).map(renderNavbarDropdown)}</>
    )}
  </ExtendedExperienceSelector>
);
